import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { NoSsr } from '@cian/react-utils';
import { clsx } from 'clsx';
import { valueToPercent } from '../helpers';
import styles from '../styles.module.css';
import colorsStyles from '@cian/ui-kit-design-tokens/colors/colors.module.css';
import deprecatedColorsStyles from '@cian/ui-kit-design-tokens/colors/deprecated/colors.module.css';
import ColorScale from 'color-scales';
import { getColorProps } from '../../../../utils/getColorProps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const colorsScaleGradientsMap = {
  'skeleton-primary': ['#f3f6ff', '#f3f6ff', '#ffffff', '#f3f6ff', '#f3f6ff'],
  'brand-public-primary': ['#ffe1ff', '#006cfd'],
  'brand-public-secondary': ['#ffe1ff', '#c1e8fd'],
  'brand-b2b-primary': ['#000000', '#031d40', '#006cfd', '#ffe1ff', '#ffdcc8', '#ffebaf'],
  'brand-b2b-secondary': ['#ffffff', '#ffebaf', '#ffdcc8', '#ffe1ff', '#006cfd', '#031d40'],
  'brand-mortgage-primary': ['#ffdcc8', '#9ec1fe', '#006cfd'],
  'brand-mortgage-secondary': ['#ffdcc8', '#c1e8fd'],
  'brand-owner-primary': ['#ffebaf', '#87aee8', '#006cfd'],
  'brand-owner-secondary': ['#ffebaf', '#c1e8fd'],
  'brand-commercial-primary': ['#ffe1ff', '#ffebaf', '#ffdcc8'],
  'brand-commercial-secondary': ['#ffffff', '#006cfd'],
  'brand-commercial-tertiary': ['#006cfd', '#000000']
};
export function SliderMarks(props) {
  const {
    values,
    marks,
    min,
    max,
    trackLeap,
    color,
    marksTextColor = 'gray60_100'
  } = props;
  const lastIndex = marks.length - 1;
  const colorScale = React.useMemo(() => {
    if (colorsScaleGradientsMap[color]) {
      return new ColorScale(min, trackLeap, colorsScaleGradientsMap[color]);
    }
    return;
  }, [color, min, trackLeap]);
  return /*#__PURE__*/_jsx(NoSsr, {
    children: marks.map((mark, index) => {
      const {
        value,
        label
      } = mark;
      const percent = valueToPercent(value, min, max);
      const isActive = getIsActive(value, values);
      const style = {
        left: "".concat(percent, "%")
      };
      const markColor = getColor(percent, color, colorScale);
      const markStyle = _objectSpread(_objectSpread({}, style), {}, {
        background: isActive ? markColor : undefined
      });
      const isFirst = index === 0;
      const isLast = index === lastIndex;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          style: markStyle,
          className: clsx(styles['mark'], isActive && styles['active'], isFirst && styles['first'], isLast && styles['last'])
        }), label && /*#__PURE__*/_jsx("span", {
          "aria-hidden": true,
          style: style,
          className: clsx(styles['mark-label'], isFirst && styles['first'], isLast && styles['last'], colorsStyles["color_".concat(marksTextColor)], deprecatedColorsStyles["color_".concat(marksTextColor)]),
          children: label
        })]
      }, value);
    })
  });
}
function getColor(percent, color, colorScale) {
  var _getColorProps$style;
  if (!color) {
    return;
  }
  return colorsScaleGradientsMap[color] ? colorScale === null || colorScale === void 0 ? void 0 : colorScale.getColor(percent).toHexString() : (_getColorProps$style = getColorProps(color).style) === null || _getColorProps$style === void 0 ? void 0 : _getColorProps$style.color;
}
function getIsActive(value, values) {
  const isRange = values.length >= 2;
  if (isRange) {
    return value >= values[0] && value <= values[values.length - 1];
  }
  return value <= values[0];
}